import PlanejamentoAcaoJustificativa from '../../produto/spa/planejamento-acao/PlanejamentoAcaoJustificativa';

export default PlanejamentoAcaoJustificativa;
